/**
 * Created by Mark on 24/04/2017.
 */



import ApplicationServices from './base-service.js';
import Constants from '../constants.js';

class SearchService {

    searchLearning(searchTerm , language , local){
        return ApplicationServices.call(Constants.GET_VOCAB_TEXT_SEARCH , {fromLanguage:local , toLanguage:language , searchTerm:searchTerm}).then(function(response){
            return response;
        });
    }


    globalSearch(string){

        return ApplicationServices.call(Constants.GET_GLOBAL_TEXT_SEARCH , {searchString:string}).then(function(response){
            return response.results;
        });
    }

}

export default new SearchService();
